<app-bread-crumb [items]="[{text:'cores'}]" [sectionTitle]="'Lista de  Cores'"></app-bread-crumb>

<section class="content">

  <div class="row">

    <div class="col-md-12">

      <!-- inicio do box -->
      <ng-box [boxIcon]="'fa fa-list'" [boxTitle]="'Cores'">

        <!-- cabesalho do box -->
        <ng-container class="ng-box-header">

          <ng-button (click)="create()"
            [button]="{name:'nova cor', faIconClass:'fa fa-plus',color:'danger'}">
          </ng-button>

        </ng-container>

        <!-- box-content -->
        <ng-container class="ng-box-content">

          <!-- inicio da tabela -->
          <ng-table [tableHeaderAndFooterColumns]="tableProprieties()" *ngIf="!isSpinnerLoading">

            <tr *ngFor="let color of objects" ngChangeColorOnHover>
                <td>{{ color?.cody }}</td>
                <td>{{ color?.description }}</td>
     
              <!-- controles -->
              <ng-actions-table-bar>

                <ng-button title="Editar" (click)="edit(color)" [button]="{faIconClass:'fa fa-edit',color:'danger'}">
                </ng-button>

                <ng-button title="Excluir" (click)="delete(color)"
                  [button]="{faIconClass:'fa fa-close',color:'danger'}"></ng-button>

              </ng-actions-table-bar>

            </tr>

          </ng-table>
          <!-- fim da tabela -->

          <box-loading class="overlay" *ngIf="isSpinnerLoading"></box-loading>

        </ng-container>
        <!-- fim do conteudo do box -->
      </ng-box>
      <!-- fim do box -->
    </div>
  </div>
</section>